import React from 'react';
import { Link } from 'react-router-dom';
import PlatformVisual from './PlatformVisual';
import { useMarket } from '../../context/MarketContext';

const Hero: React.FC = () => {
  const { market } = useMarket();
  const isIndia = market === 'IN';

  return (
    <section className="relative pt-20 pb-16 sm:pb-24 overflow-hidden">

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-50 dark:bg-dark-800/50 border border-primary-200 dark:border-dark-700 mb-8 animate-fade-in">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <span className="text-sm text-slate-700 dark:text-dark-300 font-medium">
            {isIndia ? 'Pharmacy ERP + machine shop software' : 'Manufacturing ERP for CNC machine shops'}
          </span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-display font-bold mb-6 animate-slide-up">
          <span className="text-slate-900 dark:text-white">
            {isIndia ? 'Pharmacy ERP,' : 'Machine shop ERP,'}
          </span>
          <br />
          <span className="gradient-text">made Cimmple</span>
        </h1>

        {/* Subheading */}
        <p className="text-lg sm:text-xl text-slate-700 dark:text-dark-300 max-w-3xl mx-auto mb-10 animate-slide-up animate-delay-100">
          {isIndia
            ? 'CimmpleRx pharmacy billing software and CimmpleFlow machine shop ERP for Indian businesses—GST, inventory, and shop operations in one cloud platform.'
            : 'CimmpleFlow is cloud ERP for manufacturing and CNC job shops: quoting, purchasing, production, quality, inventory, accounting, and AI automation in one machine shop operating system.'}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slide-up animate-delay-200">
          {isIndia ? (
            <>
              <Link to="/products" className="btn-primary text-lg px-8 py-4">
                Explore Products
                <svg className="inline-block ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
              <Link to="/pricing" className="btn-secondary text-lg px-8 py-4">
                View Pricing
              </Link>
            </>
          ) : (
            <>
              <Link to="/contact" className="btn-primary text-lg px-8 py-4">
                Book a Demo
                <svg className="inline-block ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
              <Link to="/pricing?product=cimmple" className="btn-secondary text-lg px-8 py-4">
                Start Free Trial
              </Link>
            </>
          )}
        </div>

        <PlatformVisual />
      </div>
    </section>
  );
};

export default Hero;
